(function() {
  'use strict';

  /**
   * Schutz für CustomPhoto-Bilder im Warenkorb
   * Verhindert Rechtsklick, Drag & Drop, Long-Press und andere Interaktionen
   */
  function protectCustomPhotoImages() {
    // Finde alle Bilder die CustomPhoto im Pfad haben oder das data-Attribut besitzen
    const customPhotoImages = document.querySelectorAll(
      'img[src*="CustomPhoto"], img[data-src*="CustomPhoto"], img[data-custom-photo="true"]'
    );

    customPhotoImages.forEach(img => {
      // Rechtsklick verhindern
      img.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        return false;
      });

      // Drag & Drop verhindern
      img.addEventListener('dragstart', (e) => {
        e.preventDefault();
        return false;
      });

      // Long-press auf Mobil verhindern
      let touchTimer;
      img.addEventListener('touchstart', (e) => {
        touchTimer = setTimeout(() => {
          e.preventDefault();
        }, 500);
      });

      img.addEventListener('touchend', () => {
        if (touchTimer) clearTimeout(touchTimer);
      });

      img.addEventListener('touchcancel', () => {
        if (touchTimer) clearTimeout(touchTimer);
      });

      // Markiere Bild als geschützt
      img.setAttribute('data-custom-photo', 'true');
    });

    if (customPhotoImages.length > 0) {
      console.log('[Panda Theme] Protected', customPhotoImages.length, 'CustomPhoto images');
    }
  }

  // Initial Schutz anwenden
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', protectCustomPhotoImages);
  } else {
    protectCustomPhotoImages();
  }

  // Schutz auch nach AJAX-Updates anwenden (z.B. Warenkorb-Updates)
  document.addEventListener('cart:updated', protectCustomPhotoImages);
  $(document).on('cartUpdated', protectCustomPhotoImages);

  // Observer für dynamisch hinzugefügte Bilder
  const observer = new MutationObserver((mutations) => {
    let shouldProtect = false;
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            if (node.tagName === 'IMG' || node.querySelector('img')) {
              shouldProtect = true;
            }
          }
        });
      }
    });
    if (shouldProtect) {
      protectCustomPhotoImages();
    }
  });

  // Observer starten wenn DOM bereit ist
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  } else {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
